export enum FormCategories {
  n400 = "n400",
  n600 = "n600",
  n565 = "n565",
  ds160 = "ds160",
}
